/* Mitra cart drawer: item count, 10%/15% milestone bar, upsells, bill summary, savings, trust row, sticky footer */
(function () {
  if (window.__mitraCartDrawer) return;
  window.__mitraCartDrawer = true;

  var BRAND = '#7a1212';
  var GREEN = '#1a7f37';
  var TIERS = [{ n: 2, pct: 10 }, { n: 3, pct: 15 }];
  var MAX_ITEMS = TIERS[TIERS.length - 1].n;
  var STRIP_TEXT = 'Extra 5% off on UPI, Card &amp; Netbanking';
  var TRUST = ['🚚 Free delivery', '💵 COD available', '🔒 Secure payments'];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productsCache = null;

  var css = '' +
    '.mcd-count{font-weight:400;font-size:.8em;margin-left:6px}' +
    'cart-drawer .drawer__header{padding:12px 0 10px!important}' +
    'cart-drawer .drawer__heading{font-size:22px!important}' +
    'cart-drawer .cart-progress{display:none!important}' + 'cart-drawer .cart-drawer-items-and-upsell{min-height:0!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch}' +
    '.mcd-ms{padding:8px 0 10px;border-bottom:1px solid #eee}' +
    '.mcd-ms-text{font-size:13px;font-weight:700;text-align:center;color:#1a1a1a;margin-bottom:8px}' +
    '.mcd-ms-text em{font-style:normal;color:' + BRAND + '}' +
    '.mcd-ms-track{position:relative;height:4px;border-radius:4px;background:#eadcdc;margin:0 10px}' +
    '.mcd-ms-fill{position:absolute;left:0;top:0;bottom:0;border-radius:4px;background:' + BRAND + ';transition:width .4s}' +
    '.mcd-ms-dot{position:absolute;top:50%;width:14px;height:14px;margin:-7px 0 0 -7px;border-radius:50%;background:#eadcdc;border:2px solid #fff;box-shadow:0 0 0 1px #eadcdc}' +
    '.mcd-ms-dot.on{background:' + BRAND + ';box-shadow:0 0 0 1px ' + BRAND + '}' +
    '.mcd-ms-labels{position:relative;height:14px;margin:6px 10px 0;font-size:10px;color:#777}' +
    '.mcd-ms-labels span{position:absolute;transform:translateX(-50%);white-space:nowrap}' +
    '.mcd-ms-labels span:last-child{transform:translateX(-100%)}' +
    'cart-drawer .cart-item td{padding-top:14px!important}' +
    'cart-drawer .cart-item td.cart-item__quantity{padding-top:4px!important}' +
    'cart-drawer .cart-item__image{width:64px!important;height:64px!important;border-radius:8px;object-fit:cover}' +
    'cart-drawer .cart-item__media{width:64px!important}' +
    'cart-drawer .cart-item__name{font-family:inherit!important;font-size:14px!important;font-weight:600!important;line-height:1.3!important;display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    'cart-drawer .cart-item .product-option{font-size:12px!important;margin-top:2px!important}' +
    'cart-drawer .cart-item__totals{width:auto!important;white-space:nowrap}' +
    'cart-drawer .cart-item__totals .price{font-size:14px!important;letter-spacing:0!important}' +
    'cart-drawer .cart-item__old-price{font-size:12px!important;display:block}' +
    'cart-drawer .quantity{min-height:30px!important;height:30px!important;width:92px!important}' +
    'cart-drawer .quantity__input{height:30px!important}' +
    '.mcd-wrap{padding:0 1.5rem 1rem}' +
    '.mcd-offer{display:flex;align-items:center;gap:10px;margin:14px 0 10px;font-weight:700;font-size:13px;color:#1a1a1a}' +
    '.mcd-offer:after{content:"";flex:1;min-width:20px;height:1px;background:#e8a0a0}' +
    '.mcd-row{display:flex;gap:10px;overflow-x:auto;padding-bottom:6px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none}' +
    '.mcd-row::-webkit-scrollbar{display:none}' +
    '.mcd-card{flex:0 0 calc((100% - 20px) / 3);min-width:0;scroll-snap-align:start}' +
    '.mcd-img{position:relative;border-radius:12px;overflow:hidden;aspect-ratio:1/1;background:#f3f3f3}' +
    '.mcd-img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.mcd-add{position:absolute;top:6px;right:6px;width:26px;height:26px;border-radius:7px;border:1px solid #222;background:#fff;color:#222;font-size:18px;line-height:22px;text-align:center;cursor:pointer;padding:0}' +
    '.mcd-add[disabled]{opacity:.5;cursor:wait}' +
    '.mcd-title{font-size:12px;line-height:1.3;margin:8px 0 2px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:#1a1a1a}' +
    '.mcd-opts{font-size:11px;color:#888;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' + '.mcd-vwrap{position:relative;display:block;margin-top:3px;height:24px;overflow:hidden}' + '.mcd-vwrap:after{content:"\\25BE";position:absolute;right:6px;top:3px;font-size:11px;color:#555;pointer-events:none}' + '.mcd-var{-webkit-appearance:none;appearance:none;display:block;width:133.33%;height:32px;font-size:16px;line-height:1.2;padding:0 26px 0 8px;margin:0;border:1px solid #d8d8d8;border-radius:8px;background:#fff;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transform:scale(.75);transform-origin:0 0;cursor:pointer}' +
    '.mcd-price{font-size:13px;font-weight:700;margin-top:2px;color:#1a1a1a;white-space:nowrap}' +
    '.mcd-price s{font-weight:400;color:#999;font-size:11px;margin-left:4px}' +
    '.mcd-bill{margin-top:18px}' +
    '.mcd-bill h3{font-family:inherit;font-size:15px;font-weight:700;margin:0 0 8px;color:#1a1a1a}' +
    '.mcd-line{display:flex;justify-content:space-between;font-size:13px;padding:4px 0;color:#333}' +
    '.mcd-line.green{color:' + GREEN + '}' +
    '.mcd-line s{color:#999;margin-right:6px}' +
    '.mcd-line.grand{border-top:1px dashed #ddd;margin-top:6px;padding-top:10px;font-size:15px;font-weight:700;color:#1a1a1a}' +
    'cart-drawer .cart-drawer__footer{display:none!important}' +
    'cart-drawer .drawer__footer{padding:0!important;border-top:0!important}' +
    '.mcd-save{background:#e9f6ec;color:' + GREEN + ';text-align:center;font-weight:700;font-size:12px;padding:6px 12px}' +
    '.mcd-strip{background:' + BRAND + ';color:#fff;text-align:center;font-weight:700;font-size:12px;padding:7px 12px}' +
    'cart-drawer .cart__ctas{display:flex!important;align-items:center;gap:14px;padding:10px 15px 6px!important;margin:0!important}' +
    '.mcd-total{flex:0 0 auto;line-height:1.2}' +
    '.mcd-total b{display:block;font-size:16px;color:#1a1a1a}' +
    '.mcd-total a{font-size:11px;color:#777;text-decoration:underline;cursor:pointer}' +
    'cart-drawer #CartDrawer-Checkout{flex:1;margin:0!important;background:' + BRAND + '!important;color:#fff!important;border-radius:12px!important;min-height:46px!important;font-weight:700;font-size:15px!important;letter-spacing:.3px!important}' +
    'cart-drawer #CartDrawer-Checkout:after,cart-drawer #CartDrawer-Checkout:before{box-shadow:none!important}' +
    '@media (max-width:380px){.mcd-ms-text{font-size:12px!important}.mcd-offer{font-size:12px!important}}.mcd-trust{display:flex;flex-wrap:wrap;justify-content:center;gap:2px 12px;padding:0 15px calc(10px + env(safe-area-inset-bottom));font-size:10.5px;color:#555;white-space:nowrap}' +
    'body:has(cart-drawer.active) #webux-whatsapp-button{display:none!important}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function money(paise) {
    var v = Math.round(paise) / 100;
    return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function rupees(str) { return Math.round(parseFloat(str || 0) * 100); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function getProducts() {
    if (productsCache) return Promise.resolve(productsCache);
    return fetch(root + 'products.json?limit=20').then(function (r) { return r.json(); }).then(function (d) {
      productsCache = d.products || [];
      return productsCache;
    }).catch(function () { return []; });
  }

  function variantMap(products) {
    var m = {};
    products.forEach(function (p) { p.variants.forEach(function (v) { m[v.id] = v; }); });
    return m;
  }

  function mrpTotal(cart, vmap) {
    var mrp = 0;
    cart.items.forEach(function (i) {
      var v = vmap[i.variant_id];
      var cmp = v ? rupees(v.compare_at_price) : 0;
      mrp += Math.max(cmp, i.original_price) * i.quantity;
    });
    return mrp;
  }

  function upsellHTML(products, cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var list = products.filter(function (p) {
      return !inCart[p.id] && p.variants.some(function (v) { return v.available; });
    });
    if (!list.length) return '';
    return list.map(function (p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      var pick = avail.slice().sort(function (a, b) { return rupees(a.price) - rupees(b.price); })[0];
      var img = p.images && p.images[0] ? p.images[0].src : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
      var cmp = rupees(pick.compare_at_price);
      var price = rupees(pick.price);
      var picker = avail.length > 1 ? '<span class="mcd-vwrap"><select class="mcd-var" aria-label="Choose size for ' + esc(p.title) + '">' + avail.map(function (v) { return '<option value="' + v.id + '" data-price="' + rupees(v.price) + '" data-cmp="' + rupees(v.compare_at_price) + '"' + (v.id === pick.id ? ' selected' : '') + '>' + esc(v.title) + '</option>'; }).join('') + '</select></span>' : '<div class="mcd-opts">' + esc(pick.title === 'Default Title' ? '1 option' : pick.title) + '</div>';
      return '<div class="mcd-card">' +
        '<div class="mcd-img">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') +
        '<button type="button" class="mcd-add" data-variant="' + pick.id + '" aria-label="Add ' + esc(p.title) + ' ' + esc(pick.title) + '">+</button></div>' +
        '<div class="mcd-title">' + esc(p.title) + '</div>' +
        picker +
        '<div class="mcd-price">' + money(price) + (cmp > price ? '<s>' + money(cmp) + '</s>' : '') + '</div>' +
        '</div>';
    }).join('');
  }

  function billHTML(cart, mrp) {
    var rows = '<div class="mcd-line"><span>Item total (MRP)</span><span>' + money(mrp) + '</span></div>';
    var mrpDisc = mrp - cart.original_total_price;
    if (mrpDisc > 0) rows += '<div class="mcd-line green"><span>Discount on MRP</span><span>-' + money(mrpDisc) + '</span></div>';
    var other = cart.original_total_price - cart.total_price;
    var listed = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      listed += d.total_allocated_amount;
      rows += '<div class="mcd-line green"><span>' + esc(d.title) + '</span><span>-' + money(d.total_allocated_amount) + '</span></div>';
    });
    if (other - listed > 0) rows += '<div class="mcd-line green"><span>Product discounts</span><span>-' + money(other - listed) + '</span></div>';
    rows += '<div class="mcd-line"><span>Delivery</span><span class="mcd-line green" style="padding:0">FREE</span></div>';
    rows += '<div class="mcd-line grand"><span>Grand Total</span><span>' + money(cart.total_price) + '</span></div>';
    return '<h3>Bill summary</h3>' + rows;
  }

  function nextTier(count) {
    for (var i = 0; i < TIERS.length; i++) if (count < TIERS[i].n) return TIERS[i];
    return null;
  }
  function currentTier(count) {
    var t = null;
    TIERS.forEach(function (x) { if (count >= x.n) t = x; });
    return t;
  }
  function plural(n) { return n + ' more item' + (n > 1 ? 's' : ''); }

  function offerText(cart) {
    var next = nextTier(cart.item_count);
    if (next) return '🔥 Pick any ' + (next.n - cart.item_count) + ' to unlock ' + next.pct + '% OFF';
    return 'You may also like';
  }

  function milestoneHTML(cart) {
    var count = cart.item_count;
    var next = nextTier(count);
    var cur = currentTier(count);
    var pct = Math.min(100, Math.round((count / MAX_ITEMS) * 100));
    var text;
    if (next && cur) text = '🎉 ' + cur.pct + '% OFF unlocked! <em>' + (next.n - count) + ' more</em> for <em>' + next.pct + '% OFF</em>';
    else if (next) text = 'Add <em>' + plural(next.n - count) + '</em> to get <em>' + next.pct + '% OFF</em>';
    else text = '🎉 Yay! You’ve unlocked <em>' + cur.pct + '% OFF</em>';
    var dots = '', labels = '';
    for (var i = 1; i <= MAX_ITEMS; i++) {
      var left = Math.round((i / MAX_ITEMS) * 100);
      var tier = null;
      TIERS.forEach(function (x) { if (x.n === i) tier = x; });
      dots += '<span class="mcd-ms-dot' + (count >= i ? ' on' : '') + '" style="left:' + left + '%"></span>';
      labels += '<span style="left:' + left + '%">' + (tier ? i + ' · ' + tier.pct + '%' : i + ' item' + (i > 1 ? 's' : '')) + '</span>';
    }
    return '<div class="mcd-ms-text">' + text + '</div>' +
      '<div class="mcd-ms-track"><div class="mcd-ms-fill" style="width:' + pct + '%"></div>' + dots + '</div>' +
      '<div class="mcd-ms-labels">' + labels + '</div>';
  }

  var busy = false;
  function enhance() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || busy) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner || inner.querySelector('.mcd-wrap')) return;
    if (drawer.classList.contains('is-empty') || !drawer.querySelector('.cart-item')) return;
    busy = true;
    Promise.all([fetch(root + 'cart.js').then(function (r) { return r.json(); }), getProducts()]).then(function (res) {
      var cart = res[0], products = res[1];
      busy = false;
      if (!cart.item_count || inner.querySelector('.mcd-wrap')) return;
      var vmap = variantMap(products);
      var mrp = mrpTotal(cart, vmap);
      var saved = mrp - cart.total_price;

      inner.querySelectorAll('.cart-item .price').forEach(function (e) {
        if (!e.children.length) e.textContent = e.textContent.replace(/Rs\.\s*([\d,]+)(\.00)?/, '₹$1');
      });
      var lbl = inner.querySelector('#CartDrawer-Checkout .button__label');
      if (lbl) lbl.textContent = 'Checkout';

      var heading = inner.querySelector('.drawer__heading');
      if (heading && !heading.querySelector('.mcd-count')) {
        heading.insertAdjacentHTML('beforeend', '<span class="mcd-count">(' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ')</span>');
      }

      var header = inner.querySelector('.drawer__header');
      if (header && !inner.querySelector('.mcd-ms')) {
        header.insertAdjacentHTML('afterend', '<div class="mcd-ms">' + milestoneHTML(cart) + '</div>');
      }

      var wrap = document.createElement('div');
      wrap.className = 'mcd-wrap';
      var ups = upsellHTML(products, cart);
      wrap.innerHTML = (ups ? '<div class="mcd-offer">' + offerText(cart) + '</div><div class="mcd-row">' + ups + '</div>' : '') +
        '<div class="mcd-bill" id="mcd-bill">' + billHTML(cart, mrp) + '</div>';
      var host = inner.querySelector('.cart-drawer-items-and-upsell') || inner.querySelector('cart-drawer-items');
      if (host) host.appendChild(wrap);

      var ctas = inner.querySelector('.cart__ctas');
      if (ctas && !inner.querySelector('.mcd-strip')) {
        var top = (saved > 0 ? '<div class="mcd-save">🎉 You’re saving ' + money(saved) + ' on this order!</div>' : '') +
          '<div class="mcd-strip">' + STRIP_TEXT + '</div>';
        ctas.insertAdjacentHTML('beforebegin', top);
        ctas.insertAdjacentHTML('afterbegin', '<div class="mcd-total"><b>' + money(cart.total_price) + '</b><a class="mcd-view">View Details</a></div>');
        ctas.insertAdjacentHTML('afterend', '<div class="mcd-trust">' + TRUST.map(function (t) { return '<span>' + t + '</span>'; }).join('') + '</div>');
      }
    }).catch(function () { busy = false; });
  }

  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var parser = new DOMParser();
      var drawer = document.querySelector('cart-drawer');
      var doc = parser.parseFromString(s['cart-drawer'], 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var newDrawer = doc.querySelector('cart-drawer');
      if (drawer && newInner) {
        drawer.querySelector('.drawer__inner').innerHTML = newInner.innerHTML;
        if (newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var b = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (b) bubble.innerHTML = b.innerHTML;
      }
    });
  }

  document.addEventListener('change', function (e) { var sel = e.target.closest && e.target.closest('.mcd-var'); if (!sel) return; var card = sel.closest('.mcd-card'); var opt = sel.options[sel.selectedIndex]; var price = Number(opt.getAttribute('data-price')); var cmp = Number(opt.getAttribute('data-cmp')); card.querySelector('.mcd-add').setAttribute('data-variant', opt.value); card.querySelector('.mcd-price').innerHTML = money(price) + (cmp > price ? '<s>' + money(cmp) + '</s>' : ''); }); document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.mcd-add');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-variant')), quantity: 1 }] })
      }).then(refreshDrawer).catch(function () { add.disabled = false; });
      return;
    }
    var view = e.target.closest && e.target.closest('.mcd-view');
    if (view) {
      e.preventDefault();
      var bill = document.getElementById('mcd-bill');
      if (bill) bill.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(enhance, 60); }
  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
